export default __webpack_public_path__ + "static/media/center02.21e6b7ff.jpg";